import React from "react";
import { Grid, Typography } from "@material-ui/core/";
import { makeStyles } from "@material-ui/styles";
import IconGoBack from "./assets/images/goBack";
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles({
  "@global": {
    "html, body": {
      margin: 0,
      padding: 0
    }
  },
  root: {
    height: 97,
    fontSize: '18px !important'
  },

  label: {
    width: 60,
    cursor: "pointer"
  },

  icon: {
    height: 24,
    transform: 'rotate(180deg)',
    transformOrigin: '50% 50%',
    lineHeight: '28px',
    marginRight: 5,
    display: 'flex',
    alignItems: 'center'
  },
  fSize18: {
    fontSize: 18
  },
  "@media screen and (max-device-width : 767px)": {
    root: {
      height: 65
    }
  }
});

const GoBack = () => {
  const classes = useStyles();
  const history = useHistory();
  const handleGoBack = () => history.goBack();

  return (
    <Grid container item className={classes.root}>
      <Grid container item justify="flex-start" alignItems="center" direction="row" className={classes.label} onClick={handleGoBack} >
        <Typography component="p" className={`${classes.icon} ${classes.fSize18}`}>
          <IconGoBack />
        </Typography>
        <Typography component="p" className={classes.fSize18}>戻る</Typography>
      </Grid>
    </Grid>
  );
};

export default GoBack;
